import { cn } from '@/lib/cn'

// The Facebul mark: a scan frame around a mesh-graph face. Drawn as vector so it stays crisp at
// every size and can be tinted per theme (gradient on light, solid white on dark).
function MarkPaths({ paint }: { paint: string }) {
  return <g stroke={paint} strokeLinecap="round" strokeLinejoin="round" fill="none">
    {/* scan frame corners */}
    <g strokeWidth={5}>
      <path d="M20 6h-8a6 6 0 0 0-6 6v8" />
      <path d="M44 6h8a6 6 0 0 1 6 6v8" />
      <path d="M6 44v8a6 6 0 0 0 6 6h8" />
      <path d="M58 44v8a6 6 0 0 1-6 6h-8" />
    </g>
    {/* mesh edges */}
    <g strokeWidth={1.3}>
      <path d="M30 16 21 22M30 16l4 9M21 22l13 3M21 22l3 8M34 25l-10 5M34 25l2 7M24 30l-6 7M24 30l5 7M18 37h11M29 37l7-5M18 37l5 8M29 37l-6 8M23 45l8 6M29 37l2 14" />
    </g>
    {/* mesh nodes */}
    <g fill={paint} stroke="none">
      <circle cx="30" cy="16" r="1.9" />
      <circle cx="21" cy="22" r="1.9" />
      <circle cx="34" cy="25" r="1.9" />
      <circle cx="24" cy="30" r="1.9" />
      <circle cx="18" cy="37" r="1.9" />
      <circle cx="29" cy="37" r="1.9" />
      <circle cx="36" cy="32" r="1.9" />
      <circle cx="23" cy="45" r="1.9" />
      <circle cx="31" cy="51" r="1.9" />
      {/* eye */}
      <circle cx="43" cy="26" r="3.4" />
    </g>
    {/* smile */}
    <path d="M33 42q7 9 13-4" strokeWidth={3.6} />
  </g>
}

export function FacebulMark({ className }: { className?: string }) {
  return <svg viewBox="0 0 64 64" role="img" aria-label="Facebul" className={cn('block', className)}>
    <defs>
      <linearGradient id="facebul-mark-grad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#38bdf8" />
        <stop offset="0.5" stopColor="#6366f1" />
        <stop offset="1" stopColor="#2563eb" />
      </linearGradient>
    </defs>
    <g className="dark:hidden"><MarkPaths paint="url(#facebul-mark-grad)" /></g>
    <g className="hidden dark:block"><MarkPaths paint="currentColor" /></g>
  </svg>
}

/// Loading state built from the same mark: the scan frame pulses while the mesh draws itself in.
export function FacebulLoader({ className, label }: { className?: string; label?: string }) {
  return <span role="status" aria-label={label ?? 'Yükleniyor'} className={cn('inline-grid place-items-center', className)}>
    <svg viewBox="0 0 64 64" className="size-full animate-pulse text-brand">
      <defs>
        <linearGradient id="facebul-loader-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#38bdf8" />
          <stop offset="0.5" stopColor="#6366f1" />
          <stop offset="1" stopColor="#2563eb" />
        </linearGradient>
      </defs>
      <MarkPaths paint="url(#facebul-loader-grad)" />
    </svg>
  </span>
}
